// extracted by mini-css-extract-plugin
export var actionsRow = "_j-a";
export var actionsRowEnd = "_j-b";
export var askRedoBlackBtn = "_j-d";
export var askRedoBlackBtnIcon = "_j-e";
export var exitModalActionBtn = "_j-c";
export var exitModalRoot = "_j-0";
export var followUpInput = "_j-9";
export var modalContentBody = "_j-7";
export var modalHeaderImage = "_j-2";
export var modalImageLabel = "_j-4";
export var modalImageOverlay = "_j-3";
export var modalImageSubheading = "_j-6";
export var modalImageTitle = "_j-5";
export var modalImageWrapper = "_j-1";
export var reasonCard = "_j-f";
export var reasonCardSelected = "_j-g";
export var reasonIcon = "_j-j";
export var reasonIconWrap = "_j-i";
export var reasonIndicator = "_j-l";
export var reasonIndicatorDot = "_j-n";
export var reasonIndicatorSelected = "_j-m";
export var reasonLabel = "_j-h";
export var reasonList = "_j-8";
export var reasonTitle = "_j-k";